<template>
	<div>
    <Header :sticky="headerSticky" v-if="headerVisibility"></Header>
    <router-view/>
    <Footer v-if="footerVisibility"></Footer>
    <cookie-law theme="dark-lime" v-if="cookieEnabled && !stillLoading"></cookie-law>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import CookieLaw from 'vue-cookie-law'
import config from '@/config'

import Header from '@/components/header'
import Footer from '@/components/footer'
import ToTop from '@/components/totop'

import "@/assets/css/menu.css"
import "@/assets/css/vendors.css"
import "@/assets/css/date_picker.css"
import "@/assets/css/custom.css"

const baseAPI = process.env.VUE_APP_API_ENDPOINT

export default {
  name: 'Main',
  components: {
    Header,
    Footer,
    ToTop,
    CookieLaw
  },
  data () {
    return {
      baseAPI
    }
  },
  computed: {
    ...mapGetters([
      'hasToken',
      'stillLoading',
      'headerVisibility',
      'footerVisibility',
      'toTopVisibility'
    ]),
    cookieEnabled () {
      return config.cookieExpires === 1
    },
    headerSticky () {
      return this.$route.meta && this.$route.meta.headerSticky
    }
  },
  methods: {
    ...mapMutations([
      'toggleHeader',
      'toggleFooter',
      'setContainer',
      'setFooterVisible',
      'setToTopVisible'
    ]),
    setTitle (route) {
      if (route.meta && route.meta.title) {
        document.title = this.$t(route.meta.title.replace(/[-]/g, '_'))
      } else {
        document.title = config.title
      }
    }
  },
  watch: {
    hasToken () {
      if (!this.hasToken && this.$route.meta.requiresAuth) {
        this.$router.replace({ name: 'login', params: { page: this.$route.name, info: { ...this.$route.params } }  })
      }
    }
  },
  mounted () {
    this.setTitle(this.$route)
  },
  beforeRouteUpdate (to, from, next) {
    this.setTitle(to)
    next()
  }
}
</script>
